export default {
  /* 使用此modal的頁面：
   * 1. 預約資料>預約單
   * 2. 派遣單>叫車紀錄總查詢 */
  openAt: '預約單',
  id: null,
  billInfo: {
    orderId: '',
    reservationType: 0,
    reservationTime: '',
    onLocation: '',
    offLocation: '',
    passengerOnLacatioNote: '',
    passengerNote: '',
    result: '',
    call_method: '',
    passengerCancel: '',
    driverCancel: '',
    passengerPhone: '',
    passengerName: '',
    actualFare: null,
    pickUpPassengerTime: null,
    finishTime: null,
    passengerCount: null,
    seatNumber: null,
    paymentMethod: '',
    needInvoice: null,
    taxId: '',
    invoiceTitle: '',
    invoiceAddress: '',
  },
  managerInfo: {
    name: '',
  },
  serviceList: null,
  serviceInfo: {
    name: '',
  },
  passengerInfo: {
    phone: '',
    name: '',
  },
  driverInfo: {
    isReply: false,
    teamName: '',
    phone: '',
    callNumber: '',
    licence: '',
    carBrand: '',
  },
  driverState: [],
}



// WEBPACK FOOTER //
// ./src/store/reserveModal/state.js